module.exports = __webpack_public_path__ + "img/dcfl10.72e206b7.png";